import React, { useEffect, useState, useRef } from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  useLocation,
} from 'react-router-dom';
import { useStyles } from './MenuList.styles';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

export interface ListItemLinkProps {
  icon?: React.ReactElement;
  primary: string;
  to: string;
  isActive: boolean;
  validPathName: string;
  showItemTooltip?: boolean;
  subMenu?: any;
  onDrawerOpen: any;
  onDrawerClose: any;
  onSubMenuDrawerOpen: any;
  handleSubMenuOpenHandle : any;
}

const ListItemLink = React.forwardRef(function ListItemLink(
  props: ListItemLinkProps,
  rootRef:
    | ((instance: HTMLLIElement | null) => void)
    | React.MutableRefObject<HTMLLIElement | null>
    | null,
) {
  const {
    icon,
    primary,
    to,
    validPathName,
    showItemTooltip,
    subMenu,
    isActive,
    onDrawerOpen,
    onDrawerClose,
    onSubMenuDrawerOpen,
    handleSubMenuOpenHandle,
    ...rest
  } = props;
  const { classes } = useStyles();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [isActiveLink, setIsActive] = useState<boolean>(
    to === location.pathname || validPathName === location.pathname,
  );

  useEffect(() => {
    setIsActive(
      to.split('/')[1] === location.pathname.split('/')[1] || 
      to === location.pathname || validPathName === location.pathname,
    );
    setOpen(to.split('/')[1] === location.pathname.split('/')[1]);
  }, [location, to, validPathName]);

  return (
    <List
      sx={{ paddingTop: 0, paddingBottom: 0 }}
    >
      <ListItem 
        key={primary} 
        disablePadding 
        sx={{ display: 'table' }}
        className={
          isActiveLink
          ? classes.listMainMenuActive
          : classes.listItemInactive
        }
        >
          <ListItemButton
            sx={{
              minHeight: 20,
              justifyContent: open ? 'initial' : 'center',
              px: 2.5,
            }}
            component={RouterLink}
            to={subMenu ? '#' : validPathName}
            onClick={() => {
              handleSubMenuOpenHandle(primary,subMenu);
            }}
            >
            <ListItemIcon
              title={primary}
              sx={{
                minWidth: 0,
                justifyContent: 'center',
                color: '#757575'
              }}
            >
              {icon}  
            </ListItemIcon>
            <ListItemText primary={primary} title={primary} sx={{ paddingLeft: '40px' , color: '#5C6571'}} /> 
            {subMenu ? <NavigateNextIcon sx={{color: '#5C6571'}} /> : ''}
          </ListItemButton>
        </ListItem>
    </List>
  );
});

export default ListItemLink;
